import { Moon, Sun } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';

export default function ThemeToggle() {
  const { isDark, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className="p-2 rounded-xl app-text hover:bg-[var(--ui-surface-alt)] transition-colors focus:outline-none focus:ring-2 focus:ring-primary-400"
      title={isDark ? 'Passer en mode clair' : 'Passer en mode sombre'}
      aria-label={isDark ? 'Passer en mode clair' : 'Passer en mode sombre'}
    >
      {isDark ? (
        <Sun className="w-5 h-5 text-accent-400" />
      ) : (
        <Moon className="w-5 h-5 app-text-muted" />
      )}
    </button>
  );
}
